<template>
  <div class="ai-btn">
    <img
      @click="showAi"
      class="ai-btn__img"
      src="https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/ai-icon-fx-new.svg"
    />
    <ai-tools
      ref="aiTools"
      v-if="showAiService"
      v-model="showAiService"
      :openType="4"
      :sellerId="sellerId"
    />
  </div>
</template>
<script>
import AiTools from "./aiTools.vue";
export default {
  name: "AiToolsBtn",
  props: {
    type: {
      type: String,
      default: "sence",
      validator: (v) => ["sence", "hd", "message"].includes(v),
    },
    sendData: {
      type: Array,
      default: () => [],
    },
    sellerId: {
      type: String,
      default: "",
    },
  },
  components: {
    AiTools,
  },
  data() {
    return {
      showAiService: false,
    };
  },
  methods: {
    showAi() {
      let msg = "";
      if (this.type == "sence") {
        msg = "请选择报表!";
      } else if (this.type == "hd") {
        msg = "请选择互动活动!";
      } else if (this.type == "message") {
        msg = "请选择短信活动!";
      }
      if (!this.sendData.length) {
        this.$message.warning(msg);
        return;
      }
      this.showAiService = true;
      this.$nextTick(() => {
        this.$refs.aiTools.openByBtn(this.sendData, this.type);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-btn {
  display: flex;
  align-items: center;
  margin-left: 16px;
  &__img {
    cursor: pointer;
    height: 32px;
    width: 88px;
  }
}
</style>
